// extracted by mini-css-extract-plugin
module.exports = {"viewAllCommentsLabel":"comments_viewAllCommentsLabel__69ODW","mobileViewAllCommentsLable":"comments_mobileViewAllCommentsLable__1mGQw"};